import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { CommonDataService } from '../../../common/services/common-data.service';
import { HttpcallService } from '../../../common/services/httpcall.service';
import { LoginService } from '../../../common/services/Login.service';
import { OpenLinkById } from '../../../common/services/openlinkbyid';
import scrollIntoView from 'scroll-into-view-if-needed';
import { SessionService } from '../../../common/services/Session.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { constObj } from '../../../common/Constants/constants';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../common/shared-components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-page-viewer',
  templateUrl: './page-viewer.component.html',
  styleUrls: ['./page-viewer.component.css']
})

export class PageViewerComponent implements OnInit, AfterViewChecked, OnDestroy {

  publicationId;
  pageId;
  paragraphContent = [];
  pageHeading;
  printqueueAdded: boolean = false;
  paragraphIdsList: any[] = [];
  paraArticleId: string = "";
  addedparagraphList = [];
  displayWhatLinksHereBackButton = false;
  whatLinksHereBackButtonTitle: string;
  whatLinksHereBackButtonUrl: string;
  event$: Subscription;
  PendingContentPage: boolean = false;
  isFirefoxUser: boolean = false;
  PendingContentParagraph = ""
  paragraphIdHighlight: any;
  annotationContentBool: boolean = false;
  annotationPrintContentBool: boolean = false;
  originalDisplayAnnotation: boolean = false;
  isMacFirefoxUser: boolean = false;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute, private openLink: OpenLinkById,
    private router: Router, private httpCallService: HttpcallService,
    public commonDataService: CommonDataService,
    private loginService: LoginService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private graphQLService: GraphqlService,
    public dialog: MatDialog,
    private session: SessionService
  ) {
    this.isArchiveApplication();
    this.publicationId = this.router.url.split("/")[1];
    this.pageId = this.router.url.split("/")[2];
    sessionStorage.setItem("paragraphNum", this.router.url.split("/")[3]);
    this.getUserId();
    this.isFirefoxUser = (/firefox/i.test(navigator.userAgent));
    this.isMacFirefoxUser = (/firefox/i.test(navigator.userAgent));
  }

  ngOnDestroy() {
    if (this.event$ != undefined) {
      this.event$.unsubscribe()
    }
    if (this.breadcrumbSession != undefined) {
      this.breadcrumbSession.unsubscribe()
    }
    if (this.mainCalls$ != undefined) {
      this.mainCalls$.unsubscribe()
    }
    if (this.sessionCall != undefined) {
      this.sessionCall.unsubscribe()
    }
    if (this.globalLabels != undefined) {
      this.globalLabels.unsubscribe()
    }
    if (this.destroy$) {
      this.destroy$.next();
      this.destroy$.complete();
    }
    localStorage.removeItem("SetPrintQueueSession");
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");
    this.commonDataService.loadCurrentLeftNav.next(null);
  }

  mainCalls$: Subscription;
  s3ImageBasePath: string = "";
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.syncTopAndBottomScroll();
      this.observeTable();
      window.addEventListener('resize', () => {
        this.syncTopAndBottomScroll();
      });
    }, 0);
  }
  observeTable(): void {
    const observer = new MutationObserver(() => {
      this.syncTopAndBottomScroll();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  syncTopAndBottomScroll(): void {
    const topScrolls = document.querySelectorAll('.top-scroll') ;
    const bottomScrolls = document.querySelectorAll('.bottom-scroll');
    if (!topScrolls.length || !bottomScrolls.length) return;
    topScrolls.forEach((top, index) => {
      const bottom = bottomScrolls[index] as HTMLElement;
      const topElement = top as HTMLElement;
      if (!bottom) return;
      const topInner = topElement.firstElementChild as HTMLElement;
      if (topInner) {
        topInner.style.width = bottom.scrollWidth + 'px';
      }
      topElement.addEventListener('scroll', () => {
        bottom.scrollLeft = topElement.scrollLeft;
      });
      bottom.addEventListener('scroll', () => {
        topElement.scrollLeft = bottom.scrollLeft;
      });
    });
  }
  ngOnInit(): void {
    this.commonDataService.resetPrintQueue.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.paragraphIdsList = [];
      localStorage.setItem("SetPrintQueueSession", JSON.stringify({}));
    });
    this.outcome = false;
    this.firstTimeFlag = true;
    this.isStarting = true;
    this.commonDataService.showLoader.next(true);
    this.paragraphContent = [];
    this.printQueue = [];
    this.isArchiveApplication();
    this.event$
      = this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          this.outcome = false;
          this.firstTimeFlag = true;
          this.isStarting = true;
          this.printQueue = [];
          this.isArchiveApplication();
          this.commonDataService.showLoader.next(true);
          let whatLinksHereRouteValues = this.router?.getCurrentNavigation()?.extras?.state;
          if (whatLinksHereRouteValues != null) {
            if (('backLabel' in whatLinksHereRouteValues) && ('backUrl' in whatLinksHereRouteValues)) {
              this.displayWhatLinksHereBackButton = true;
              this.whatLinksHereBackButtonTitle = whatLinksHereRouteValues?.backLabel?.targetLevelThree;
              this.whatLinksHereBackButtonUrl = whatLinksHereRouteValues?.backUrl;
            }
            else {
              this.displayWhatLinksHereBackButton = false;
            }
          }
          else {
            this.displayWhatLinksHereBackButton = false;
          }

          //this.publicationId = this.route.snapshot.parent?.params.publicationId;
          //this.pageId = this.route.snapshot.params.pageId;
          this.publicationId = this.router.url.split("/")[1];
          this.pageId = this.router.url.split("/")[2];
          sessionStorage.setItem("paragraphNum", this.router.url.split("/")[3]);
          this.MapLoginData(this.loggedInUserInfo);
          this.commonDataService.annotationWithinContent.next(null);
          this.commonDataService.displayallannotation.next("default");
          localStorage.removeItem("SetPrintQueueSession");
          this.commonDataService.glossaryTermFromContentPageBackButton.next("");
        })
    this.commonDataService.displayallannotation.next("default");
    this.commonDataService.annotationWithinContent.subscribe(data => {
      if (data != "" && data != null) {
        this.commonDataService.showLoader.next(true);
        this.annotationContentBool = false;
        this.annotationPrintContentBool = false;
        this.fetchPageAnnotations("displayallannotations", data);
        this.commonDataService.annotationWithinContent.next("");
      }
    });

    this.commonDataService.displayallannotation.subscribe(data => {
      if (data == "displayallannotations" || data == "displayallannotationswithprint") {
        this.commonDataService.showLoader.next(true);
        this.annotationPrintContentBool = false;
        this.annotationContentBool = false;
        this.fetchPageAnnotations(data, "");
      }
      else if (data == "hidePrintallannotations") {
        this.annotationPrintContentBool = false;
        if (this.originalDisplayAnnotation) { this.fetchPageAnnotations("displayallannotations", "RecoverAll"); }
        this.paragraphForAnnotation = [];
      }
      else if (data == "hideallannotations") {
        this.annotationContentBool = false;
        this.originalDisplayAnnotation = false;
        this.annotationPrintContentBool = false;
        this.paragraphForAnnotation = [];
      }
      else {
        this.annotationPrintContentBool = false;
        this.annotationContentBool = false;
      }
    });
    this.commonDataService.printCount.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == "toggleOff") {
        this.paragraphIdsList = [];
        this.printQueue = JSON.parse(localStorage.getItem("OriginalPrintQueue")) == null ? [] : JSON.parse(localStorage.getItem("OriginalPrintQueue"));
      }
    })
    this.commonDataService.addAnnotationParagraphId.subscribe(data => {
      if (data != "" && data != null) {
        this.annotationCount[data] = parseInt((this.annotationCount[data] == undefined || this.annotationCount[data] == null) ? '0' : this.annotationCount[data]) + 1;
        this.commonDataService.addAnnotationParagraphId.next("");
        if (this.annotationContentBool && this.paragraphForAnnotation.includes(data)) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", data);
        } else if (this.annotationContentBool && this.paragraphForAnnotation.length == 0) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", "");
        }
      }
    })

    this.commonDataService.updateAnnotationParagraphId.subscribe(data => {
      if (data != "" && data != null) {
        if (this.annotationContentBool && this.paragraphForAnnotation.includes(data)) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", data);
        } else if (this.annotationContentBool && this.paragraphForAnnotation.length == 0) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", "");
        }
      }
    })
    this.commonDataService.deleteAnnotationParagraphId.subscribe(data => {
      if (data != "") {
        this.annotationCount[data] = parseInt((this.annotationCount[data] == undefined || this.annotationCount[data] == null) ? '0' : this.annotationCount[data]) - 1;
        if (this.annotationContentBool && this.paragraphForAnnotation.includes(data)) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", data);
        } else if (this.annotationContentBool && this.paragraphForAnnotation.length == 0) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", "");
        }
        this.commonDataService.deleteAnnotationParagraphId.next("");
      }
    })
    this.commonDataService.addBookmarkParagraphId.subscribe(data => {
      if (data != "") {
        this.bookmarkCount[data] = parseInt((this.bookmarkCount[data] == undefined || this.bookmarkCount[data] == null) ? '0' : this.bookmarkCount[data]) + 1;
        this.commonDataService.addBookmarkParagraphId.next("");
      }
    })
    this.commonDataService.deleteBookmarkParagraphId.subscribe(data => {
      if (data != "") {
        this.bookmarkCount[data] = parseInt((this.bookmarkCount[data] == undefined || this.bookmarkCount[data] == null) ? '0' : this.bookmarkCount[data]) - 1;
        this.commonDataService.deleteBookmarkParagraphId.next("");
      }
    })
    //this.commonDataService.printToggleOff.subscribe(data => {
    //  if (data == "printToggleOff") {
    //    this.printqueueAdd = "false";
    //    this.printqueueAddBool = false;
    //    this.menuList.value = false;
    //  }
    //})

  }
  archiveVersion: string = "";
  isArchive: boolean = false;
  isArchiveApplication() {
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.isArchive = true;
      this.archiveVersion = this.convertMonthYear(localStorage.getItem("ArchiveVersion"));
    }
    else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId")) {
      this.isArchive = true;
      this.archiveVersion = localStorage.getItem("ArchiveVersion");
      this.commonDataService.loadCurrentLeftNav.next(this.router.url.split("/")[1]);
    }
    else { this.isArchive = false; }
  }
  firstTimeFlag: boolean = true;
  isStarting: boolean = true;
  ngAfterViewChecked(): void {
    let para = sessionStorage.getItem("paragraphNum");
    if (sessionStorage.getItem('backButtonClicked') === 'false') {
      if (this.isStarting) {
        if (!(para === "undefined" || para === null)) {
          if (para.includes("__")) {
            let para1 = para.replace(para.split("__")[0] + "__", "");
            if (document.getElementById(para) != null) {
              setTimeout(function () {
                // document.getElementById(para).scrollIntoView(true);
                scrollIntoView(document.getElementById(para), {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  behavior: 'smooth',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
                const element = document.getElementById(para);
                const rect = element.getBoundingClientRect();
                const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                const viewPortHeight = window.innerHeight;
                const top1Percent = viewPortHeight * 0.01;
                const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                const maxScrollTop = documentHeight - viewPortHeight;
                if (rect.top < top1Percent || scrollTop >= maxScrollTop) {
                  sessionStorage.removeItem("paragraphNum");
                  this.isStarting = false;
                }
              }, 2000);
            }
            else if (document.getElementById(para1) != null) {
              setTimeout(function () {
                // document.getElementById(para).scrollIntoView(true); 
                scrollIntoView(document.getElementById(para1), {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  behavior: 'smooth',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
                const element = document.getElementById(para1);
                const rect = element.getBoundingClientRect();
                const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                const viewPortHeight = window.innerHeight;
                const top1Percent = viewPortHeight * 0.01;
                const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                const maxScrollTop = documentHeight - viewPortHeight;
                if (rect.top < top1Percent || scrollTop >= maxScrollTop) {
                  sessionStorage.removeItem("paragraphNum");
                  this.isStarting = false;
                }
              }, 2000);
            }
          } else {
            if (document.getElementById(para) != null) {
              setTimeout(function () {
                // document.getElementById(para).scrollIntoView(true); 
                scrollIntoView(document.getElementById(para), {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  behavior: 'smooth',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
                const element = document.getElementById(para);
                const rect = element.getBoundingClientRect();
                const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                const viewPortHeight = window.innerHeight;
                const top1Percent = viewPortHeight * 0.01;
                const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                const maxScrollTop = documentHeight - viewPortHeight;
                if (rect.top < top1Percent || scrollTop >= maxScrollTop) {
                  sessionStorage.removeItem("paragraphNum");
                  this.isStarting = false;
                }
              }, 2000);
            }
          }
        }
      }
    }

    if (this.firstTimeFlag && this.outcome) {
      this.firstTimeFlag = false;
      //this.getstatusStylings();
      //this.setLineBreak();
      if (this.elementRef.nativeElement.querySelector('.inline-glossary')) {
        this.elementRef.nativeElement.querySelector('.inline-glossary').addEventListener('click', this.redirectInlineGlossary.bind(this));
      }
    }
  }

  remove(arr, what) {
    arr.sort().forEach(function (value, index) {
      if (value.value === what) {
        arr.splice(index, 1);
      }
    });
  }
  bypasstrusthtml(text) {
    text = this.sanitizer.bypassSecurityTrustHtml(text)
    return text;
  }

  temppageHeadingId: string = "";
  pageHeadingId: string = "";
  printQueue: any = [];
  linkerList: any[] = [];
  bookmarkCount: any = {};
  annotationCount: any = {};
  getPageContent(publicationId: string, pageId: string, pageName: string) {
    this.mainCalls$ = forkJoin([
      this.graphQLService.getPageData(publicationId, pageId, this.pageNavPath, this.navTitlePath, this.isArchive),
      this.graphQLService.getS3BucketImagePath(),
      this.graphQLService.getGlobalLabels()
    ]).subscribe(([result, s3BucketImagePath, data]) => {
      this.s3ImageBasePath = s3BucketImagePath;
      //debugger;
      this.temppageHeadingId = result.headingName == "" ? pageName : result.headingName.split('____')[1];
      this.pageHeading = result.headingName == "" ? pageName : this.sanitizer.bypassSecurityTrustHtml(result.headingName.split('____')[0]);
      this.pageHeadingId = result.paragraphContent.length > 0 ? result.paragraphContent[0].id : "noId";
      this.paragraphContent = result.paragraphContent;
      //this.paragraphContent = this.paragraphContent.filter(x => x.paraContent = this.sanitizer.bypassSecurityTrustHtml(x.paraContent));
      if (this.paragraphContent != null) {
        for (let i = 0; i < this.paragraphContent.length; i++) {
          if (this.paragraphContent[i].paragraphHeading != null) {
            let tempParaHeadingId = [];
            for (let j = 0; j < this.paragraphContent[i].paragraphHeading.length; j++) {
              tempParaHeadingId.push(this.paragraphContent[i].paragraphHeading[j] != "" ? this.paragraphContent[i].paragraphHeading[j].split('____')[1] : "");
              this.paragraphContent[i].paragraphHeading[j] = this.paragraphContent[i].paragraphHeading[j] != "" ? this.sanitizer.bypassSecurityTrustHtml(this.paragraphContent[i].paragraphHeading[j].split('____')[0]) : "";
            }
            this.paragraphContent[i].paragraphHeadingId = tempParaHeadingId;
          }
          this.paragraphContent[i].paraContent = this.sanitizer.bypassSecurityTrustHtml(this.paragraphContent[i].paraContent);
        }
      }
      this.footnote = result.footnote;
      this.footnote = this.footnote.filter(x => x.footnoteBody = this.sanitizer.bypassSecurityTrustHtml(x.footnoteBody));
      this.tocContent = result.tocContent;
      let tempArr: any[] = [];
      tempArr.push(result.printParagraphs);
      this.printQueue = tempArr;
      localStorage.setItem("OriginalPrintQueue", JSON.stringify(this.printQueue));
      this.getActionMenuLabels(data);
      this.outcome = true;
      this.commonDataService.showLoader.next(false);
      this.getPrintSession();
    }, err => {
      console.log(err);
    });
    if (this.userRole != "Basic" && (!this.isArchive)) {
      let paragraphActionInputBody = { NavigationPath: "GARS", Application: "" };
      forkJoin([this.httpCallService.getBookmarkCount(paragraphActionInputBody), this.httpCallService.getAnnotationCount(paragraphActionInputBody)])
        .subscribe(([bookmarkCount, annotationCount]) => {
          this.bookmarkCount = bookmarkCount; this.annotationCount = annotationCount;
          this.saveHistory();
        });
    }
  }

  getPrintSession() {
    this.addedparagraphList = [];
    this.paragraphIdsList = [];
    let printQueueData = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
    if (printQueueData) {
      if (printQueueData != null && printQueueData.ParagraphIdsList != null) {
        this.addedparagraphList = printQueueData.ParagraphIdsList;
        this.paragraphIdsList = printQueueData.ParagraphIdsList;
      }
    }
  }

  breadcrumbPath: string = "";
  saveHistory() {
    if (this.breadcrumbPath !== "" && this.breadcrumbPath?.split("~")[0] != "Other Reference") {
      let history = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "GARS", "CreateDate": "", "UpdateDate": "", "BreadCrumb": this.breadcrumbPath, "NavPath": this.breadcrumbPath, "PageURL": this.router.url };
      this.httpCallService.addHistory(history).toPromise()
        .then(resp => console.log(resp))
        .catch(res => {
          console.log(res);
        });
    }
  }

  paragraphForAnnotation: string[] = [];
  pageAnnotationsForPrint: any = {};
  pageAnnotations: any = {};
  fetchPageAnnotations(option, paragraphId) {
    if (this.mailId != "" && this.mailId != null) {
      let inputBody = { "NavigationPath": "GARS", "Application": "GARS", "paragraphId": paragraphId };
      this.httpCallService.getPageAnnotation(inputBody).subscribe(data => {
        if (option == "displayallannotations") {
          if (paragraphId == "RecoverAll") {
            for (let para in this.paragraphForAnnotation) {
              this.pageAnnotations[para] = data[para];
            }
          }
          else if (paragraphId != "RecoverAll" && paragraphId != "") {
            if (this.pageAnnotations == {} || this.paragraphForAnnotation.length == 0) {
              this.pageAnnotations = data;
              if (!this.paragraphForAnnotation.includes(paragraphId)) {
                this.paragraphForAnnotation.push(paragraphId);
              }
            } else {
              this.pageAnnotations[paragraphId] = data[paragraphId];
              if (!this.paragraphForAnnotation.includes(paragraphId)) {
                this.paragraphForAnnotation.push(paragraphId);
              }
            }
            this.originalDisplayAnnotation = true;
          } else {
            this.paragraphForAnnotation = [];
            this.pageAnnotations = data;
            this.originalDisplayAnnotation = true;
          }
          this.commonDataService.showLoader.next(false);
          this.annotationContentBool = true;
        } else if (option == "displayallannotationswithprint") {
          this.pageAnnotationsForPrint = data;
          this.commonDataService.showLoader.next(false);
          this.annotationPrintContentBool = true;
        }
      })
    }
  }

  tocContent: any = "";
  footnote: any[] = [];

  outcome: boolean = false;
  //getParagraphs(body: any) {
  //  this.tocContent = "";
  //  let paragraphs : any;
  //  this.footnote = [];
  //  if (body.pnumbody != null && body.pnumbody.length > 0) {
  //    paragraphs = body.pnumbody;
  //  }
  //  else {
  //    paragraphs = body.rawResponse;
  //  }
  //  if (body.tocContent != null && body.tocContent != "") {
  //    this.tocContent = this.sanitizer.bypassSecurityTrustHtml(body.tocContent);
  //  }

  //  if (body.footnote != null && body.footnote.length > 0) {
  //    body.footnote.forEach(info => {
  //      let obj = {
  //        footnoteSymbolHtml: this.sanitizer.bypassSecurityTrustHtml(info.footnoteSymbolHtml),
  //        footnoteSymbol: info.footnoteSymbol,
  //        footnoteBody: this.sanitizer.bypassSecurityTrustHtml(info.footnoteBody)
  //      }
  //      this.footnote.push(obj);
  //    })
  //  }
  //  //paragraphs = this.paragraph[1].split(">")[1].split("</div>");
  //  //for (var i = 1; i < this.paragraph.length; i++) {
  //  //  var part = this.paragraph[i].substring(
  //  //    this.paragraph[i].indexOf(">") + 1,
  //  //    this.paragraph[i].lastIndexOf("</div>")
  //  //  );
  //  //  paragraphs.push(part);
  //  //}
  //  let count = 1;
  //  this.paragraphContent = [];
  //  let printTemp: boolean = false;

  //  if (body.pnumbody != null && body.pnumbody.length > 0) {
  //    for (let i = 0; i < paragraphs.length; i++) {
  //      if (paragraphs[i].pId != "") {
  //        let temp = {
  //          id: paragraphs[i].pId,
  //          paraNum: paragraphs[i].pnum == "" || paragraphs[i].pnum == null ? (this.linkerList[paragraphs[i].autoNumberId] == undefined ? "" : "." + this.linkerList[paragraphs[i].autoNumberId]) : (paragraphs[i].pnum.charAt(paragraphs[i].pnum.length - 1) == '.' ? paragraphs[i].pnum : paragraphs[i].pnum + "."),
  //          paraContent: this.sanitizer.bypassSecurityTrustHtml(paragraphs[i].body),
  //          PrintQueueAdded: false,
  //          actionLabel: this.userRole != "Basic" ? this.menuListItems : [],
  //          paragraphHeading: paragraphs[i].pHeadings,
  //          subHeading: this.sanitizer.bypassSecurityTrustHtml(paragraphs[i].subHead),
  //          subTitle: paragraphs[i].subTitle == null ? "" : this.sanitizer.bypassSecurityTrustHtml(paragraphs[i].subTitle),
  //          nestedId: paragraphs[i].nestedId
  //        }
  //        this.paragraphContent.push(temp);
  //      } else {
  //        this.paragraphContent[this.paragraphContent.length - 1].paraContent = this.sanitizer.bypassSecurityTrustHtml(this.paragraphContent[this.paragraphContent.length - 1].paraContent.changingThisBreaksApplicationSecurity + paragraphs[i].body);
  //      }
  //      if (this.userRole != "Basic") {
  //        this.PendingContentParagraph = (this.PendingContentPage ? this.paragraphIdHighlight : '');
  //      }
  //    }
  //  }
  //  else {
  //    let temp = {
  //      id: paragraphs.responseId,
  //      paraNum: "",
  //      paraContent: this.sanitizer.bypassSecurityTrustHtml(paragraphs.responseBody),
  //      PrintQueueAdded: false,
  //      actionLabel: this.userRole != "Basic" ? this.menuListItems : [],
  //      paragraphHeading: "",
  //      subHeading: this.sanitizer.bypassSecurityTrustHtml(""),
  //      subTitle: "",
  //      nestedId: ""
  //    }
  //    this.paragraphContent.push(temp);
  //  }
  //}
  userId: string = "";
  mailId: string = "";
  userRole: string = "";
  sessionCall: Subscription;
  getUserId() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.sessionCall = this.loginService.getSession().subscribe(data => {
        this.MapLoginData(data);
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.MapLoginData(this.session.userInfo);
    }
  }

  pageNavPath: string = "";
  navTitlePath: string = ""; //Added by Sagar for MS-373
  crumbData: string[] = [];
  getBreadcrumb() {
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < leftNavigation.length; i++) {
      this.crumbData = [];
      this.pageNavPath = "";
      this.navTitlePath = "";
      if (leftNavigation[i].itemData?.length != 0 && leftNavigation[i].rollUp != "True") {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j].itemLink != null && leftNavigation[i].itemData[j].itemLink != "" && leftNavigation[i].itemData[j].itemLink == this.publicationId + "/" + this.pageId) {
            this.crumbData.push(leftNavigation[i].item);
            this.crumbData.push(leftNavigation[i].itemData[j].item);
            this.navTitlePath = `${leftNavigation[i].item}~${leftNavigation[i].itemData[j].item}`;

            this.pageNavPath = leftNavigation[i].itemData[j].navPath;
            return this.crumbData;

          } else {
            if (leftNavigation[i].itemData[j].itemData?.length != 0 && leftNavigation[i].itemData[j].rollUp != "True") {
              for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                if (leftNavigation[i].itemData[j].itemData[k].itemLink != null && leftNavigation[i].itemData[j].itemData[k].itemLink != "" && leftNavigation[i].itemData[j].itemData[k].itemLink == this.publicationId + "/" + this.pageId) {
                  {
                    this.crumbData.push(leftNavigation[i].item);
                    this.crumbData.push(leftNavigation[i].itemData[j].item);
                    this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                    this.pageNavPath = leftNavigation[i].itemData[j].itemData[k].navPath;
                    //this.navTitlePath = leftNavigation[i].itemData[j].itemData[k].item;
                    this.navTitlePath = `${leftNavigation[i].item}~${leftNavigation[i].itemData[j].item}~${leftNavigation[i].itemData[j].itemData[k].item}`;

                    return this.crumbData;
                  }
                }
                else {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData?.length != 0 && leftNavigation[i].itemData[j].itemData[k].rollUp != "True") {
                    for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != null && leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != "" && (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData?.length == 0 || leftNavigation[i].itemData[j].itemData[k].itemData[l].rollUp == "True")) {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink == this.publicationId + "/" + this.pageId) {
                          this.crumbData.push(leftNavigation[i].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                          this.pageNavPath = leftNavigation[i].itemData[j].itemData[k].itemData[l].navPath;
                          this.navTitlePath = `${leftNavigation[i].item}~${leftNavigation[i].itemData[j].item}~${leftNavigation[i].itemData[j].itemData[k].item}~${leftNavigation[i].itemData[j].itemData[k].itemData[l].item}`;
                          return this.crumbData;
                        }
                      }
                      else {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData?.length != 0 && leftNavigation[i].itemData[j].itemData[k].itemData[l].rollUp != "True") {
                          for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].itemLink == this.publicationId + "/" + this.pageId) {
                              this.crumbData.push(leftNavigation[i].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item);
                              this.pageNavPath = leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].navPath;
                              //this.navTitlePath = leftNavigation[i].itemData[j].itemData[k].item;
                              this.navTitlePath = `${leftNavigation[i].item}~${leftNavigation[i].itemData[j].item}~${leftNavigation[i].itemData[j].itemData[k].item}~${leftNavigation[i].itemData[j].itemData[k].itemData[l].item}~${leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item}`;

                              return this.crumbData;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  loggedInUserInfo

  callPageContent(loginData, breadcrumbData) {
    this.commonDataService.navDataContentPage.next(breadcrumbData);
    this.breadcrumbPath = breadcrumbData?.join("~");
    this.commonDataService.breadcrumbPath.next(this.breadcrumbPath);
    this.commonDataService.userId.next(loginData.user.userName);
    this.commonDataService.mailId.next(loginData.user.email);
    this.userId = loginData.user.userName;
    this.mailId = loginData.user.email;
    this.userRole = loginData.user.roles;
    this.getPageContent(this.publicationId, this.pageId, breadcrumbData ? breadcrumbData[breadcrumbData?.length - 1] : {});
  }
  isAcademic: boolean = false;
  breadcrumbSession: Subscription;
  MapLoginData(loginData) {
    if (loginData != null) {
      this.loggedInUserInfo = loginData;
    }
    if (this.loggedInUserInfo.user.roles == "Academic") {
      this.isAcademic = true;
    }
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    if (leftNavigation == undefined || leftNavigation == null) {
      this.breadcrumbSession = this.graphQLService.GetBreadcrumbSession(this.publicationId + "/" + this.pageId).subscribe(data => {
        let navData = JSON.parse(JSON.stringify(data));
        this.callPageContent(loginData, navData.crumbData);
      });
    }
    else {
      this.callPageContent(this.loggedInUserInfo, this.getBreadcrumb());
    }
  }

  labelItems: any;
  globalLabels: Subscription;
  menuListItems: string[] = [];
  getActionMenuLabels(data) {
    this.menuListItems = [];
    if (data != "") {
      let labels = data.content.data.labels;
      this.labelItems = labels;
      labels = labels.filter(x => x.key.trim());
      if (this.userRole != "Basic" && (!this.isArchive)) {
        this.menuListItems.push(labels.filter(x => x.key == "addBookmark_header").map(y => y.value)[0]);
        this.menuListItems.push(labels.filter(x => x.key == "addAnnotation_header").map(y => y.value)[0]);
        this.menuListItems.push(labels.filter(x => x.key == "provideFeedback_header").map(y => y.value)[0]);
      }
      this.menuListItems.push(labels.filter(x => x.key == "print_addToQueue").map(y => y.value)[0]);
      if (this.userRole != "Basic" && (!this.isArchive)) {
        this.menuList = [
          {
            menuLinkText: this.menuListItems[0],
            isDisabled: this.isAcademic,
            value: undefined,
            isToggle: false,
            imgPath: '../../../assets/icons/BookmarkAdd.svg'
          },
          {
            menuLinkText: this.menuListItems[1],
            isDisabled: this.isAcademic,
            value: undefined,
            isToggle: false,
            imgPath: '../../../assets/icons/pencil-alt.svg'
          },
          {
            menuLinkText: this.menuListItems[3],
            isDisabled: false,
            value: true,
            isToggle: true,
            imgPath: '../../../assets/icons/Print.svg'
          }
        ];
      } else {
        this.menuList = [
          {
            menuLinkText: this.menuListItems[0],
            isDisabled: false,
            value: true,
            isToggle: true,
            imgPath: '../../../assets/icons/Print.svg'
          }
        ];
      }
    }
  }


  OpenArchive() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.rightOverlayOption.next("Archive");
  }
  OpenWhatLinksHere() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.rightOverlayOption.next("What Links Here");
  }

  backToWhatLinksHerePage() {
    this.router.navigateByUrl(this.whatLinksHereBackButtonUrl);
  }
  OpenRelatedContent() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.rightOverlayOption.next("Related content");

  }
  openLinkById(event) {
    let id = event.target.id;
    let classname = event.target.classList;
    let termClassName = event.target.parentNode.className;
    if (((id != "" && id.includes(".pdf")) || classname.contains("pdf-link")) && (termClassName != "term" || !classname.contains("term"))) {
      event.preventDefault();
      // this.openLink.openLinkById(event);     
      this.popRedirectionHelper(event, 1);
    }
    else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref" && event.srcElement.href.includes('http') && event.srcElement.href.includes('.pdf')) {
      // window.open(event.srcElement.href);      
      this.popRedirectionHelper(event.srcElement.href, 2);

    }
    else if (classname.contains("term") || termClassName == "term") {
      event.preventDefault();
      id = id == "" && classname.contains("term") ? event.target.id : id;
      id = id == "" && termClassName == "term" ? event.target.parentNode.id : id;
      if (!this.isArchive) { this.redirectInlineGlossary(id); }
      // this.popRedirectionHelper(id, 3);
    }
    else if (classname.contains("ditamap")) {
      //console.log(event.target.attributes.altSource.value.replace(".ditamap", ""))      
      let guid = event.target.attributes.altSource.value.replace(".ditamap", "");
      // this.router.navigateByUrl(guid + "/tableOfContent");     
      this.popRedirectionHelper(guid + "/tableOfContent", 4);
    }
    else {
      this.openLink.redirectToFootnote(event);
    }
  }
  /* Start -- Annonation pop-up for print queue with MS -299 */
  popRedirectionHelper(url, x) {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
      //console.log('page-viewr-popRedirectionHelper-764');
      /*var temppath: any;
      if (x == 1 || x == 2 || x == 5) {
        temppath = event.composedPath() as Array<any>;
      }*/
      localStorage.setItem("isConfirmPopup", "true");
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      /* if (x == 1 || x == 2 || x == 5) {
         dialogRef.componentInstance.temppath = temppath;
       }*/
      dialogRef.afterClosed().subscribe((result: boolean) => {
        localStorage.removeItem("isConfirmPopup");
        if (result == true) {
          switch (x) {
            case 1: {
              this.openLink.openLinkById(url);
              break;
            }
            case 2: {
              window.open(url);
              break;
            }
            case 3: {
              this.redirectInlineGlossary(url);
              break;
            }
            case 4: {
              this.router.navigateByUrl(url);
              break
            }
          }
        }
      });
      return;
    }
    else {
      switch (x) {
        case 1: {
          this.openLink.openLinkById(url);
          break;
        }
        case 2: {
          window.open(url);
          break;
        }
        case 3: {
          this.redirectInlineGlossary(url);
          break;
        }
        case 4: {
          this.router.navigateByUrl(url);
          break
        }
      }
    }
  }
  /* End -- Annonation pop-up for print queue with MS -299 */

  redirectInlineGlossary(id) {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("inline-glossary");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.glossaryTermId.next(id);
  }
  //getstatusStylings() {
  //  let ImageDivs = document.getElementsByClassName("img") as HTMLCollectionOf<HTMLImageElement>;
  //  if (ImageDivs.length > 0) {
  //    console.log(ImageDivs.length)
  //    for (let i = 0; i < ImageDivs.length; i++) {
  //      ImageDivs[i].onload = function () {
  //        console.log(ImageDivs[i].naturalWidth)
  //        if (ImageDivs[i].naturalWidth > 1050)
  //        {
  //          console.log(ImageDivs[i])
  //          ImageDivs[i].style.objectFit = "cover";
  //          ImageDivs[i].style.width = "100%";
  //          ImageDivs[i].classList.add("cover");
  //          console.log(ImageDivs[i])
  //          //console.log("Yes in")
  //          //let ratioHeight = ((ImageDivs[i].naturalWidth - 950) / ImageDivs[i].naturalWidth) * ImageDivs[i].naturalHeight;
  //          //ImageDivs[i].style.width = "550px !important";
  //          //ImageDivs[i].style.height = "550px !important";// (ImageDivs[i].naturalHeight - ratioHeight)+"px !important";
  //        }
  //        //else
  //        //{
  //        //  console.log("Not needed")
  //        //  ImageDivs[i].style.width = String(ImageDivs[i].naturalWidth) + "px";
  //        //  ImageDivs[i].style.height = String(ImageDivs[i].naturalHeight) + "px";
  //        //}
  //        //ImageDivs[i].style.maxHeight = '100%';
  //        //ImageDivs[i].style.maxWidth = '100%';
  //        ImageDivs[i].style.boxSizing = 'border-box';
  //      }
  //    }
  //  }

  //let glossaryTerms = document.getElementsByClassName("term") as HTMLCollectionOf<HTMLElement>;
  //  if (glossaryTerms != null) {
  //    for (let i = 0; i < glossaryTerms.length; i++) {
  //      glossaryTerms[i].innerText = "[" + glossaryTerms[i].id + "]";
  //    }
  //  }


  //let anchor = document.getElementsByClassName("xref") as HTMLCollectionOf<HTMLAnchorElement>;
  //  if (anchor != null) {
  //    for (let i = 0; i < anchor.length; i++) {
  //      if (anchor[i].innerHTML.includes("<sup>")) {
  //        let href = anchor[i].href;
  //        anchor[i].id = "footText" + href.split("/")[href.split("/").length - 1];
  //      }
  //    }
  //  }

  //let issuedDate = document.getElementsByClassName("gasb-issued-date") as HTMLCollectionOf<HTMLElement>;
  //  if (issuedDate != null) {
  //    for (let i = 0; i < issuedDate.length; i++) {
  //      issuedDate[i].classList.add("flex-display");
  //      //issuedDate[i].classList.add("mt-1rem");
  //      issuedDate[i].classList.add("pb-15rem");
  //      let textBlock = document.createElement("div");
  //      textBlock.innerText = "Issued: ";
  //      textBlock.className = "pr-1rem minwidth-100px";
  //      issuedDate[i].insertBefore(textBlock, issuedDate[i].firstChild);
  //    }
  //  }

  //let effectiveDate = document.getElementsByClassName("gasb-effective-date") as HTMLCollectionOf<HTMLElement>;
  //  if (effectiveDate != null) {
  //    for (let i = 0; i < effectiveDate.length; i++) {
  //      effectiveDate[i].classList.add("flex-display");
  //      effectiveDate[i].classList.add("pb-15rem");
  //      let EffectiveDateBlock = document.createElement("div");
  //      EffectiveDateBlock.innerText = "Effective Date: ";
  //      EffectiveDateBlock.className = "pr-1rem whitespace-nowrap minwidth-100px";
  //      effectiveDate[i].innerHTML = "<div>" + effectiveDate[i].innerHTML + "</div>";
  //      effectiveDate[i].insertBefore(EffectiveDateBlock, effectiveDate[i].firstChild);
  //    }
  //  }

  //let Affects = document.getElementsByClassName("gasb-affects") as HTMLCollectionOf<HTMLElement>;
  //  if (Affects != null) {
  //    for (let i = 0; i < Affects.length; i++) {
  //      Affects[i].className = Affects[i].className + " flex-display pb-15rem";
  //      let AffectedByBlock = document.createElement("div");
  //      AffectedByBlock.innerText = "Affects: ";
  //      AffectedByBlock.className = "pr-1rem whitespace-nowrap minwidth-100px";
  //      Affects[i].innerHTML = "<div>" + Affects[i].innerHTML + "</div>";
  //      Affects[i].insertBefore(AffectedByBlock, Affects[i].firstChild);
  //    }
  //  }

  //let AffectedBy = document.getElementsByClassName("gasb-affected-by") as HTMLCollectionOf<HTMLElement>;
  //  if (AffectedBy != null) {
  //    for (let i = 0; i < AffectedBy.length; i++) {
  //      AffectedBy[i].className = AffectedBy[i].className + " flex-display pb-15rem";
  //      let AffectedByBlock = document.createElement("div");
  //      AffectedByBlock.innerText = "Affected by: ";
  //      AffectedByBlock.className = "pr-1rem whitespace-nowrap minwidth-100px";
  //      AffectedBy[i].innerHTML = "<div>" + AffectedBy[i].innerHTML + "</div>";
  //      AffectedBy[i].insertBefore(AffectedByBlock, AffectedBy[i].firstChild);
  //    }
  //  }

  //let questions = document.getElementsByClassName("question") as HTMLCollectionOf<HTMLElement>;
  //  if (questions != null) {
  //    for (let i = 0; i < questions.length; i++) {
  //      let questionBlock = document.createElement("span");
  //      questionBlock.innerHTML = "Q&#8212;";
  //      questionBlock.className = "whitespace-nowrap p";
  //      questions[i].innerHTML = "<div>" + questions[i].innerHTML + "</div>";
  //      questions[i].insertBefore(questionBlock, questions[i].firstChild);
  //    }
  //  }

  //let answers = document.getElementsByClassName("answer") as HTMLCollectionOf<HTMLElement>;
  //  if (answers != null) {
  //    for (let i = 0; i < answers.length; i++) {
  //      answers[i].className = answers[i].className + " mt-1rem";
  //      let answersBlock = document.createElement("span");
  //      answersBlock.innerHTML = "A&#8212;";
  //      answersBlock.className = "whitespace-nowrap p";
  //      answers[i].innerHTML = "<div>" + answers[i].innerHTML + "</div>";
  //      answers[i].insertBefore(answersBlock, answers[i].firstChild);
  //    }
  //  }

  //let diamondLink = document.getElementsByClassName("diamond_link") as HTMLCollectionOf<HTMLElement>;
  //if (diamondLink.length > 0) {
  //  for (let i = 0; i < diamondLink.length; i++) {
  //    let span = document.createElement("span")
  //    let img = document.createElement("img");
  //    img.src = "../../../../assets/icons/Diamond.svg";
  //    img.alt = "PDF Image";
  //    img.className = "whatsNew-image ml-8px";
  //    diamondLink[i].innerHTML = "";
  //    span.appendChild(img);
  //    diamondLink[i].insertBefore(span, diamondLink[i].firstChild);
  //  }
  //}
  //}


  //setLineBreak() {
  //  let article = document.getElementById(this.paraArticleId);
  //  let newLine_article = article?.getElementsByClassName("newline");
  //  var linebreak = document.createElement("br");
  //  if (newLine_article?.length > 0) {
  //    for (let i = 0; i < newLine_article.length; i++) {
  //      newLine_article[i].appendChild(linebreak);
  //    }
  //  }
  //}
  obj: any;
  onRightClick(event: any) {
    this.obj = event;
    let classname = event.target.classList;
    let termClassName = event.target.parentNode.className;
    if (termClassName == "term" || classname.contains("term")) {
      event.preventDefault();
    }
    if (event.srcElement.parentNode.parentNode.id?.includes('_Content')) {

      try {
        event.srcElement.parentNode.parentNode.href = event.srcElement.parentNode.parentNode.href.split("/")[3] + "/" + event.srcElement.parentNode.parentNode.href.split("/")[4] + "/" + event.srcElement.parentNode.parentNode.id?.replace('_Content', '');

        return;
      }
      catch (ex) {
        console.log("ex" + ex.message);
      }
    }
    else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref" && event.srcElement.href.includes('http') && event.srcElement.href.includes('.pdf')) {
      //window.open(event.srcElement.href);
    }
    else if ((event.srcElement.parentNode.parentNode.id?.includes('footnote') || event.srcElement.parentNode.parentNode.id?.includes('fn')) && !event.srcElement.parentNode.parentNode.id?.includes('_Content')) {
      if (event.srcElement.className.includes("ditamap")) {
        // Ignoring logic for toc pages on right click
      }
      else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref"
        && !event.srcElement.className?.includes("footnote") && !event.srcElement.className?.includes("fn")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let urlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + urlLastPart);
      }
      else {
        event.srcElement.parentNode.parentNode.href = event.srcElement.parentNode.parentNode.href.split("/")[3] + "/" + event.srcElement.parentNode.parentNode.href.split("/")[4] + "/" + event.srcElement.parentNode.parentNode.id + '_Content';
      }
    }
    else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref") {
      let otherSourceUrlParts = event.target.getAttribute('href').split("/");

      let urlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + urlLastPart);
    }
  }

  BackToCurrentContent() {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.currentVersionNavigationAlert;
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home")
      }
    });
  }

  menuList: any = [];
  bookmarkarray: any[];
  deleteBookmark(paragraphId) {
    this.commonDataService.showLoader.next(true);
    this.httpCallService.getBookmark(paragraphId).subscribe((resp: any) => {
      this.bookmarkarray = resp;
      var bookmark = {
        ID: this.bookmarkarray[this.bookmarkarray.length - 1].id, TopicId: this.bookmarkarray[this.bookmarkarray.length - 1].topicId, ParagraphId: paragraphId, BookmarkTitle: this.bookmarkarray[this.bookmarkarray.length - 1].bookmarkTitle, BookMarkBreadCrumb: this.bookmarkarray[this.bookmarkarray.length - 1].bookMarkBreadCrumb, IsDeleted: true, CreatedOn: this.bookmarkarray[this.bookmarkarray.length - 1].createdOn, ModifiedOn: this.bookmarkarray[this.bookmarkarray.length - 1].modifiedOn, ApplicationSource: "GARS",
        BookmarkURL: this.bookmarkarray[this.bookmarkarray.length - 1].bookmarkURL, NavigationPath: "GARS"
      }

      this.httpCallService.addUpdateBookmark(bookmark).toPromise()
        .then(response => {
          //this.closeOverlay();
          this.commonDataService.showLoader.next(false);
          this.bookmarkCount[bookmark.ParagraphId] = parseInt((this.bookmarkCount[bookmark.ParagraphId] == undefined || this.bookmarkCount[bookmark.ParagraphId] == null) ? '0' : this.bookmarkCount[bookmark.ParagraphId]) - 1;
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.bookmarkRemovedMessage
          }
          this.commonDataService.notificationObject.next(obj);
        })
        .catch(console.log);
    }, err => {
      console.log(err)
      this.commonDataService.showLoader.next(false);
    });
  }

  openAnnotations(paragrphId, paragraphHeading, paraNum) {
    this.checkparaheadings(paragraphHeading);
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.currentParagraph.next(this.activeParaId);
    this.commonDataService.rightOverlayOption.next("Your Annotations");
    this.commonDataService.breadcrumbPath.next(this.breadcrumbPath);
  }

  paratitle: string = "";
  checkparaheadings(paragraphHeading) {
    if (paragraphHeading != null) {
      for (let i = 0; i < paragraphHeading.length; i++) {
        if (paragraphHeading[i] != '' && paragraphHeading[i] != null) {
          let span = document.createElement('span');
          span.innerHTML = paragraphHeading[i].changingThisBreaksApplicationSecurity;
          this.paratitle = span.innerText.trim().replace(/\s+/g, " ");
          if (this.activeParaNum != "" && this.activeParaNum != "Glossary") {
            this.commonDataService.showRightPanel.next(true); this.commonDataService.currentParagraphId.next(this.activeParaNum); this.activeParaNum = "";
          }
          else if (this.paratitle != null && this.paratitle != '') {
            this.commonDataService.showRightPanel.next(true);
            this.commonDataService.currentParagraphId.next(this.paratitle);
          } else {
            this.commonDataService.showRightPanel.next(true);
            this.commonDataService.currentParagraphId.next("");
          }
          break;
        } else if (i == paragraphHeading.length - 1) {
          if (this.activeParaNum != "") {
            this.commonDataService.showRightPanel.next(true); this.commonDataService.currentParagraphId.next(this.activeParaNum); this.activeParaNum = "";
          }
          else {
            this.commonDataService.showRightPanel.next(true);
            this.commonDataService.currentParagraphId.next("");
          }
        }
      }
    } else {
      if (this.activeParaNum != "") {
        this.commonDataService.showRightPanel.next(true); this.commonDataService.currentParagraphId.next(this.activeParaNum); this.activeParaNum = "";
      }
      else {
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.currentParagraphId.next("");
      }
    }
  }

  clickMenuItem(item, action) {
    if (item.isDisabled) { alert("You do not have access to this feature") }
    else {
      let width = "rightOverLay_small";
      if (item.menuLinkText.includes("Bookmark") && action == "Remove") {
        this.deleteBookmark(this.activeParaId)
        return true;
      }
      this.openRightOverlay(item.menuLinkText, width)
    }
  }

  activeParaId: string = "";
  activeParaHeading: string[] = [];
  activeParaNum: string = "";
  activeParaIteration: string = "";
  activeParaChanged(paragrphId, paragraphHeading, paraNum, paraIteration) {
    this.activeParaId = paragrphId;
    this.activeParaHeading = paragraphHeading;
    this.activeParaNum = paraNum;
    this.activeParaIteration = paraIteration;
  }


  openRightOverlay(str, width) {
    this.checkparaheadings(this.activeParaHeading);
    this.commonDataService.rightPanelWidth.next(width);
    this.commonDataService.currentParagraph.next(this.activeParaId);
    if (str == "Add Annotation") {
      this.commonDataService.annotationUpdateSource.next("");
    }
    this.commonDataService.breadcrumbPath.next(this.breadcrumbPath);
    this.commonDataService.rightOverlayOption.next(str);
  }

  printqueueAddBool: boolean = false;
  public toggle(event: MatSlideToggleChange) {
    this.printQueue[0][this.activeParaId] = event.checked;
    this.commonDataService.printqueueCount.next(event.checked.toString());
    if (event.checked) {
      this.printqueueAdded = true;
      if (this.paragraphIdsList == null) {
        this.paragraphIdsList = [];
      }
      this.paragraphIdsList.push({ key: this.pageHeading, value: this.activeParaId, paraHeading: this.activeParaHeading, paraNum: this.activeParaNum, pageNumber: "0", paraIteration: this.activeParaIteration });
      const body = {
        ParagraphIdsList: this.paragraphIdsList
      };
      localStorage.setItem("SetPrintQueueSession", JSON.stringify(body));
    }
    else {
      this.printqueueAdded = false;
      this.remove(this.paragraphIdsList, this.activeParaId);
      const _body = {
        ParagraphIdsList: this.paragraphIdsList,
      };
      localStorage.setItem("SetPrintQueueSession", JSON.stringify(_body));
    }

  }

  convertMonthYear(abbrMonthYear: string): string {
    // Define a map of abbreviated month names to full month names
    const monthMap: { [key: string]: string } = {
      "Jan": "January",
      "Feb": "February",
      "Mar": "March",
      "Apr": "April",
      "May": "May",
      "Jun": "June",
      "Jul": "July",
      "Aug": "August",
      "Sep": "September",
      "Oct": "October",
      "Nov": "November",
      "Dec": "December"
    };

    // Split the input string into month and year parts
    const [abbrMonth, year] = abbrMonthYear.split(" ");

    // Look up the full month name in the map
    const fullMonth = monthMap[abbrMonth];

    // If the abbreviation is not valid, return an error message
    if (!fullMonth) {
      return abbrMonthYear;
    }

    // Return the full month and year as a string
    return `${fullMonth} ${year}`;
  }
}
